import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { DatePicker } from 'antd';

export default class FormDatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDate: null,
    };

    this.dateFormat = 'DD/MM/YYYY';
  }

  handleCalendarChange = date => {
    this.setState({
      headerFilterDate: date || [],
    });
  };

  disabledDate = current => {
    const dates = this.state.headerFilterDate;

    if (!current) {
      return false;
    }

    if (current.diff(moment().subtract(1, 'years').startOf('years')) < 0) {
      return true;
    }

    if (!dates || dates.length === 0) {
      return false;
    }

    const tooLate = dates[0] && current.diff(dates[0], 'days') > 365;
    const tooEarly = dates[0] && moment(dates[0]).diff(current, 'days') > 365;
    return tooEarly || tooLate;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { t, dateType, initialValue, keyType } = this.props;
    return (
      <Form.Item
        colon={false}
        label={t(`landlord.reconciliation_list.filter.${keyType.toLowerCase()}.label`)}
      >
        {getFieldDecorator(dateType, { initialValue })(
          <DatePicker.RangePicker
            format={this.dateFormat}
            disabledDate={this.disabledDate}
            onCalendarChange={this.handleCalendarChange}
          />,
        )}
      </Form.Item>
    );
  }
}

FormDatePicker.propTypes = {
  t: PropTypes.func,
  initialValue: PropTypes.array,
  form: PropTypes.object,
  dateType: PropTypes.string,
  keyType: PropTypes.string,
};

FormDatePicker.defaultProps = {
  t: () => {},
  initialValue: [],
  form: {},
  dateType: '',
  keyType: '',
};
